import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../Button/Button';
import linkToClasses from './LinkTo.module.scss';

export default function LinkTo({
  href,
  variant = 'normal',
  color = 'font-primary',
  prefix,
  suffix,
  selected = false,
  button = false,
  textDecorationNone = false,
  className,
  children,
  onClick,
}) {
  const classes = !button
    ? cx(
        linkToClasses.link,
        {
          [linkToClasses.decorationNone]: textDecorationNone === true,
          [linkToClasses.button]: button,
          [linkToClasses.selected]: selected,
        },
        className,
      )
    : cx(className);

  const navigate = useNavigate();

  const handleClick = (event) => {
    if (href) {
      navigate(href);
    }
    if (onClick) onClick(event);
  };

  return (
    href &&
    (button ? (
      <Button
        variant={variant}
        pointer
        color={color}
        prefix={prefix}
        suffix={suffix}
        className={classes}
        onClick={(event) => handleClick(event)}
      >
        {children}
      </Button>
    ) : (
      <NavLink
        to={href}
        className={({ isActive }) =>
          isActive ? `${classes} ${linkToClasses.selected}` : classes
        }
        onClick={onClick}
      >
        {prefix}
        {children}
        {suffix}
      </NavLink>
    ))
  );
}

LinkTo.propTypes = {
  href: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  variant: PropTypes.string,
  color: PropTypes.string,
  textDecorationNone: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  button: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};
